import { ref } from 'vue'
import CardListRenderer from 'www/vue_components/mobile/CardList'
import apiDoctorList from 'www/vue_components/common/TheFilters/doctors/api/apiDoctorList'
import DoctorCardSkeleton from 'www/vue_components/mobile/skeletons/DoctorCardSkeleton.vue'
import getFiltersUrl from 'www/vue_components/common/TheFilters/doctors/functions/getFiltersUrl'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import populatePageWithNewData from 'www/vue_components/common/TheFilters/doctors/functions/populatePageWithNewData'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'

async function updateDoctorListPage() {
  const filtersStore = useFiltersStore()
  const commonStore = useCommonStore()
  const skeleton = ref()
  const requestUrl = getFiltersUrl()
  const isMobile = window.MOBILE_VERSION

  /**
   * Используем setTimeout, чтобы дать браузеру время обработать window.history.back()
   * при закрытии модалки, и только потом обновляем URL через replaceState.
   * Без задержки изменения в истории могут быть перезаписаны `back()`,
   * что приведёт к потере нужного состояния.
   */
  setTimeout(() => {
    window.history.replaceState(window.history.state, '', requestUrl)
  }, 200)

  if (isMobile && commonStore.domNodes.cardsContainer) {
    skeleton.value = CardListRenderer(DoctorCardSkeleton, 20)
    skeleton.value?.$mount(commonStore.domNodes.cardsContainer)
  }

  filtersStore.updateLoading(true)

  const { data } = await apiDoctorList.get(requestUrl)

  filtersStore.updateLoading(false)

  if (isMobile) {
    skeleton.value?.$destroy()
  }

  if (!data) {
    return
  }

  populatePageWithNewData(data)
}

export default updateDoctorListPage
